module.exports = __webpack_public_path__ + "0a93a00907e93c2b4195b80bd20ae197.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-16.png
// module id = 2246
// module chunks = 0